import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TodoListItem } from '@unmind/design-system';
import { getSessionPrep } from 'Book';
import type { talkEventsQuery_unmindEvents_edges_node as Event } from 'Services/BeGateway/Talk/__generated__/talkEventsQuery';
import { useTodoListItemTracking } from '../hooks/useTodoListItemTracking';

export const SessionPrepItem = ({
  session,
  userID,
}: {
  session: Event;
  userID: string;
}) => {
  const { t: translate } = useTranslation('homepage', {
    keyPrefix: 'todo_list_section.session_prep_item',
  });

  const sessionPrep = useMemo(
    () => getSessionPrep(session, userID),
    [session, userID],
  );

  const showItem = !!(sessionPrep && sessionPrep.isRequired && sessionPrep.url);

  const { trackClicked } = useTodoListItemTracking('session-prep', {
    shown: showItem,
    completed: showItem && sessionPrep.isCompleted,
  });

  if (!showItem) {
    return null;
  }

  const practitionerName = session.userProfile.firstName;

  return (
    <TodoListItem
      title={translate('title')}
      description={translate('description', {
        practitionerName,
      })}
      thumbnail={
        session.userProfile.photoUrls?.[0]?.url
          ? {
              imageUrl: session.userProfile.photoUrls[0].url,
            }
          : {
              icon: 'person',
            }
      }
      href={sessionPrep.url}
      anchor={{
        href: sessionPrep.url,
        target: '_blank',
        rel: 'noopener noreferrer',
      }}
      cta={translate('cta')}
      completed={sessionPrep.isCompleted}
      onClick={trackClicked}
    />
  );
};
